import { FI_MENU_ICON_MESSAGE_CIRCLE } from './editorjs-fi-menu-icons';

type AddToChatTuneConfig = {
  /** Called when the user picks "Add to chat" for a block (Editor.js block id). */
  onAddToChatRequested?: (blockId: string) => void;
};

/**
 * Global Editor.js block tune that adds an "Add to chat" menu item.
 * It calls `config.onAddToChatRequested(blockId)`.
 */
export default class AddToChatTune {
  static get isTune() {
    return true;
  }

  private readonly api: any;
  private readonly config: AddToChatTuneConfig;
  private readonly block: any;

  // Editor.js tune constructors may receive optional `config`, so we keep this signature loose.
  constructor({ api, config, block }: any) {
    this.api = api;
    this.config = config ?? {};
    this.block = block;
  }

  private getTunedBlockId(): string | null {
    const rawId =
      this.block?.id ??
      this.block?.blockId ??
      this.block?.holder?.dataset?.blockId ??
      this.block?.holder?.dataset?.id;

    if (typeof rawId === 'string' && rawId.trim().length > 0) return rawId;

    return null;
  }

  render() {
    const t = this.api?.i18n?.t as undefined | ((key: string) => string);
    const title = t?.('Add to chat') ?? 'Add to chat';

    const blockId = this.getTunedBlockId();

    return {
      icon: FI_MENU_ICON_MESSAGE_CIRCLE,
      title,
      closeOnActivate: true,
      onActivate: () => {
        const cb = this.config?.onAddToChatRequested;
        if (typeof cb !== 'function') return;

        if (!blockId) return;

        cb(blockId);
      },
    };
  }
}
